import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { X, Download } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/utils/api';

const EmailCaptureModal = ({ isOpen, onClose, downloadUrl, downloadName, resourceTitle }) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Submit email capture to backend
      await api.post('/lead-capture', {
        name,
        email,
        source: 'buyer_guide_download',
        resource_title: resourceTitle
      });

      toast.success('Thank you! Your download will start shortly.');
      
      // Trigger download
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = downloadName;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Reset and close
      setEmail('');
      setName('');
      onClose();
    } catch (error) {
      toast.error('Failed to process request. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="mb-6">
          <h2 className="text-2xl font-bold mb-2">Download Your Free Guide</h2>
          <p className="text-gray-600">
            Enter your information to receive instant access to our comprehensive Home Buyer's Guide.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="capture-name">Full Name *</Label>
            <Input
              id="capture-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="John Doe"
              required
              disabled={isSubmitting}
            />
          </div>

          <div>
            <Label htmlFor="capture-email">Email Address *</Label>
            <Input
              id="capture-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="john@example.com"
              required
              disabled={isSubmitting}
            />
          </div>

          <p className="text-xs text-gray-500">
            By downloading, you agree to receive occasional updates from Bespoke Realty. 
            You can unsubscribe at any time.
          </p>

          <Button
            type="submit"
            className="w-full bg-[#BCA480] hover:bg-[#a89470]"
            disabled={isSubmitting}
          >
            <Download className="h-4 w-4 mr-2" />
            {isSubmitting ? 'Processing...' : 'Get My Free Guide'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default EmailCaptureModal;
